import http from "../http-common";

class LeadService {
  create(body: any) {
    return http.post("/CrearLead", body);
  }
}

export default new LeadService();